import { FramedIcon } from '@heidi/design-system/framed-icon';
import { TypographyCaption, TypographyPBold } from '@heidi/design-system/typography';
import { BellOff, MoreHorizontal } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

const MenuIcon = () => (
  <span className="relative -top-px inline-flex size-4 items-center justify-center rounded-sm bg-background-tertiary align-middle">
    <MoreHorizontal size={12} className="text-text-primary" />
  </span>
);

export const NotificationsDisabled = () => (
  <div className="flex flex-col items-center gap-4 px-10 pb-8 pt-4">
    <FramedIcon state="neutral" size="lg" icon={<BellOff />} />
    <div className="flex flex-col gap-1 text-center">
      <TypographyPBold>
        <FormattedMessage defaultMessage="Notifications disabled" id="XA9G97IpDI" />
      </TypographyPBold>
      <TypographyCaption className="text-text-secondary">
        <FormattedMessage
          defaultMessage="Configure your notification settings with the <icon></icon> menu"
          id="5ZcZFYodrI"
          values={{
            icon: () => <MenuIcon />,
          }}
        />
      </TypographyCaption>
    </div>
  </div>
);
